import React, { useContext } from "react";
import { fetchAgreements } from "data/actions/agreementsActions";
import { fetchChecklistItems } from "data/actions/checklistItemsActions";
import WithFinaidYears from "components/data/WithFinaidYears";
import FinancialAidYearContext from "components/contexts/FinancialAidYearContext";
import { Card, CardBody, CardTitle, RightArrowLink } from "components/ui/Card";
import Spinner from "components/ui/Spinner";
import { NetCost } from "./FinancialAidSummaryCard/NetCost";
import { FundingOffered } from "./FinancialAidSummaryCard/FundingOffered";
import { FinaidSummaryFooter } from "./FinancialAidSummaryCard/FinaidSummaryFooter";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { AidYearSelector } from "./FinancialAidSummaryCard/AidYearSelector";
import AidYearTaskCount from "react/components/_finances/AidYearTaskCount";
import { dispatchFunction } from "components/hooks/dispatchFunction";
import { FinaidDataNotAvailable } from "./FinancialAidSummaryCard/FinaidDataNotAvailable";
import { ErrorBoundary } from "components/ui/ErrorBoundary";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+Financial+Aid+and+Scholarships+Summary+Card
export function FinancialAidSummaryCard() {
  return (
    <ErrorBoundary title="Financial Aid & Scholarships">
      <WithFinaidYears>
        <FinancialAidSummaryCardUI />
      </WithFinaidYears>
    </ErrorBoundary>
  );
}

function FinancialAidSummaryCardUI() {
  dispatchFunction([fetchAgreements, fetchChecklistItems]);

  const { loadState, aidYear, aidYears, onSummaryPage, aidYearSummaries } =
    useContext(FinancialAidYearContext);

  const aidYearSummary = aidYear ? aidYearSummaries[aidYear.id] : null;

  return (
    <Card data-testid="financial-aid-summary-card">
      <CardTitle>
        <h2>Financial Aid &amp; Scholarships</h2>

        {onSummaryPage && aidYear && aidYear.id && (
          <RightArrowLink
            to={`finaid/${aidYear.id}`}
            data-testid="financial-aid-view-awards-header"
          >
            View Awards
          </RightArrowLink>
        )}
      </CardTitle>
      <CardBody>
        {loadState === "pending" && <Spinner />}
        {loadState === "failure" && (
          <>
            <div>
              <i
                className="fa fa-exclamation-triangle cc-icon cc-icon-gold"
                aria-hidden="true"
              ></i>
              An error occurred while trying to retrieve your data.
            </div>
          </>
        )}

        {loadState === "success" && aidYears.length > 0 && (
          <>
            <AidYearSelector />
            <AidYearTaskCount year={aidYear?.id} />
            <LargeSpacer />
            <NetCost currentYearAid={aidYearSummary} />
            <LargeSpacer />
            <FundingOffered currentYearAid={aidYearSummary} />
            <FinaidSummaryFooter aidYear={aidYear} />
          </>
        )}

        {loadState === "success" && aidYears.length === 0 && (
          <FinaidDataNotAvailable />
        )}
      </CardBody>
    </Card>
  );
}
FinancialAidSummaryCard.displayName = "FinancialAidSummaryCard";
